import LeadsService from "@/api/services/leads";
import { toCamelCase } from "@estaly/ui";

const initialState = {
  isLoading: false,
  index: {},
};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    getIndex(state) {
      return state.index;
    },
    isLoading(state) {
      return state.isLoading;
    },
  },
  mutations: {
    setIndex(state, index) {
      state.index = index;
    },
    setLoading(state, isLoading) {
      state.isLoading = isLoading;
    },
  },
  actions: {
    async fetchIndex({ commit }, params) {
      commit("setLoading", true);
      const response = await LeadsService.fetchIndex(params);
      commit("setLoading", false);
      if (!response?.success) return response;

      const { data } = response;
      const camelData = toCamelCase(data);
      commit("setIndex", camelData);
      return camelData;
    },

    async create(_, { storeId, params, options }) {
      const response = await LeadsService.create(storeId, params, options);
      if (!response?.success) return null;
      return toCamelCase(response.data);
    },
  },
};
